var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    { class: ["parking-sly", _vm.modify] },
    _vm._l(_vm.listPretty.slice().reverse(), function (item) {
      return _c(
        "li",
        {
          key: item.id,
          class: [
            "parking-sly__item",
            { "is-disabled": item.disabled },
            { "is-active": Number(item.id) === Number(_vm.activeId) },
          ],
          on: {
            click: function ($event) {
              !item.disabled && _vm.$emit("click", item)
            },
          },
        },
        [
          _c("span", { staticClass: "parking-sly__count" }, [
            _vm._v("\n            " + _vm._s(item.count)),
            !item.count ? _c("span", [_vm._v("0")]) : _vm._e(),
            _vm._v(" " + _vm._s(item.countWord) + "\n        "),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "parking-sly__number" }, [
            _vm._v(_vm._s(item.number)),
          ]),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }